import styled from '@emotion/styled';
import { ReactElement } from 'react';

import { Theme } from '../../../../theme/interface/detailed';
import { useTheme } from '../../../../theme/useTheme';
import { Interface } from '../interface';

export const VideoIcon = styled((props: Interface): ReactElement => {
	const theme = useTheme();

	return (
		<div {...props}>
			<svg
				width={theme.videoCalls.icons.videoIcon.width}
				height={theme.videoCalls.icons.videoIcon.height}
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M14.0193 18.4615H5.36544C3.93467 18.4615 2.76929 17.2507 2.76929 15.7615V8.23845C2.76929 6.74925 3.93467 5.53845 5.36544 5.53845H14.0193C15.4501 5.53845 16.6154 6.74925 16.6154 8.23845V15.7615C16.6154 17.2507 15.4501 18.4615 14.0193 18.4615ZM5.36544 7.33845C4.8889 7.33845 4.50006 7.74165 4.50006 8.23845V15.7615C4.50006 16.2583 4.8889 16.6615 5.36544 16.6615H14.0193C14.4958 16.6615 14.8847 16.2583 14.8847 15.7615V8.23845C14.8847 7.74165 14.4958 7.33845 14.0193 7.33845H5.36544Z"
					fill={theme.videoCalls.icons.videoIcon.fill}
				/>
				<path
					d="M20.3793 16.4561C20.1019 16.4561 19.822 16.3805 19.5773 16.2293L15.6579 13.8029C15.2315 13.5389 15.1031 12.9833 15.3696 12.5621C15.6349 12.1409 16.1947 12.0125 16.6211 12.2753L20.0776 14.4149V8.66332L16.6211 10.8029C16.1934 11.0657 15.6349 10.9373 15.3696 10.5161C15.1031 10.0949 15.2327 9.53932 15.6579 9.27532L19.5773 6.84892C20.0461 6.55972 20.6325 6.54652 21.1147 6.80932C21.5945 7.07332 21.8937 7.57612 21.8937 8.12092V14.9549C21.8937 15.4997 21.5945 16.0037 21.1135 16.2677C20.8857 16.3937 20.6325 16.4561 20.3793 16.4561Z"
					fill={theme.videoCalls.icons.videoIcon.fill}
				/>
			</svg>
		</div>
	);
})(({ theme }: { theme?: Theme }) => theme?.videoCalls.icons.videoIcon);
